<template>
    <section id="NuestrosClientes" class="clients-showcase" aria-labelledby="clients-title">
        <header class="clients-heading">
            <div>
                <span class="section-kicker">EMPRESAS QUE CONFÍAN EN NOSOTROS</span>
                <h2 id="clients-title">Construimos soluciones junto a nuestros clientes</h2>
            </div>
            <p>Experiencia aplicada en organizaciones con operaciones, industrias y retos distintos.</p>
        </header>

        <div class="logo-grid" aria-label="Clientes de Chill Byte Solutions">
            <article
                v-for="(client, index) in clients"
                v-show="visibleClients[index]"
                :key="client.name"
                class="logo-panel client-reveal"
                :style="{ animationDelay: `${index * 100}ms` }"
            >
                <span class="logo-index">0{{ index + 1 }}</span>
                <img :src="client.logo" :alt="client.name" loading="lazy">
                <span class="client-sector">{{ client.sector }}</span>
            </article>
        </div>
    </section>
</template>

<script>
export default {
    name: "NuestrosClientes",
    data() {
        return {
            visibleClients: [false, false, false],
            clients: [
                { name: "Buena Prensa", sector: "Editorial", logo: require("../../assets/img/homepage/Logo-BP.webp") },
                { name: "CINVESTAV", sector: "Investigación", logo: require("../../assets/img/clientes/logocinves.png") },
                { name: "Zavería", sector: "Industria", logo: require("../../assets/img/clientes/zaveria-horizontal.webp") }
            ],
            observer: null,
            revealTimers: []
        };
    },
    mounted() {
        if (typeof window === "undefined" || typeof window.IntersectionObserver === "undefined") {
            this.visibleClients = this.clients.map(() => true);
            return;
        }

        this.observer = new window.IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return;

            this.clients.forEach((client, index) => {
                const timer = window.setTimeout(() => this.$set(this.visibleClients, index, true), index * 120);
                this.revealTimers.push(timer);
            });
            this.observer.unobserve(this.$el);
        }, { rootMargin: "0px 0px -80px", threshold: 0.15 });

        this.observer.observe(this.$el);
    },
    beforeDestroy() {
        if (this.observer) this.observer.disconnect();
        this.revealTimers.forEach(timer => window.clearTimeout(timer));
    }
};
</script>

<style scoped>
.clients-showcase {
    padding: 24px 0;
}

.clients-heading {
    display: grid;
    grid-template-columns: 1.25fr .75fr;
    align-items: end;
    gap: 70px;
    margin-bottom: 42px;
}

.section-kicker {
    display: block;
    margin-bottom: 16px;
    color: #073b8c;
    font-size: .74rem;
    font-weight: 800;
    letter-spacing: .12em;
}

.clients-heading h2 {
    max-width: 720px;
    margin: 0;
    color: #101828;
    font-size: clamp(2rem, 3.7vw, 3.1rem);
    font-weight: 800;
    line-height: 1.08;
}

.clients-heading p {
    margin: 0 0 4px;
    color: #475467;
    font-size: 1rem;
    line-height: 1.7;
}

.logo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-top: 1px solid #dbe3ee;
    border-left: 1px solid #dbe3ee;
    background: #fff;
}

.logo-panel {
    position: relative;
    min-height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 38px 28px;
    border-right: 1px solid #dbe3ee;
    border-bottom: 1px solid #dbe3ee;
    overflow: hidden;
    transition: background-color .25s ease;
}

.logo-panel:hover {
    background: #f8faff;
}

.logo-panel img {
    width: 100%;
    max-width: 190px;
    height: 82px;
    object-fit: contain;
    filter: grayscale(1);
    opacity: .72;
    transition: filter .25s ease, opacity .25s ease, transform .25s ease;
}

.logo-panel:hover img {
    filter: grayscale(0);
    opacity: 1;
    transform: scale(1.04);
}

.logo-index,
.client-sector {
    position: absolute;
    color: #98a2b3;
    font-size: .67rem;
    font-weight: 750;
    letter-spacing: .08em;
}

.logo-index { top: 16px; left: 18px; font-family: "IBM Plex Mono", monospace; }
.client-sector { right: 18px; bottom: 14px; text-transform: uppercase; }

.client-reveal {
    animation: client-reveal .55s ease both;
}

@keyframes client-reveal {
    from { opacity: 0; transform: translateY(18px); }
    to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 767px) {
    .clients-heading { grid-template-columns: 1fr; gap: 16px; margin-bottom: 30px; }
    .logo-grid { grid-template-columns: 1fr; }
    .logo-panel { min-height: 155px; }
}

@media (prefers-reduced-motion: reduce) {
    .client-reveal { animation: none; }
    .logo-panel, .logo-panel img { transition: none; }
}
</style>